(function(window, angular, undefined) {
    var app = angular.module('formApp');
    app.directive("anzModal", [function() {
        return {
            restrict: "EA",
            link: function($scope, element, attrs, ctrl) {
                element.on("click", function(e){

                    var dialog = this.getAttribute('data-class'), 
                    modalMain = document.getElementById(dialog),
                    m = modalMain, p = document.getElementById('modal-focus'),
                    closeModalButton = document.querySelector('#' + dialog + ' .modal-close'),
                    returnQuote = document.getElementsByClassName('return-quote'),
                    openModalButton = e.currentTarget,
                    modal = document.querySelector('#' + dialog + ' .modal-dialog');

                    swap();  
                    openDialog();     

                    //run closeDialog() on click of close/return to quote buttons
                    angular.element(closeModalButton).on('click', function(){
                        closeDialog();
                    }); 

                    angular.element(returnQuote).on('click', function(){
                        closeDialog();
                    }); 

                    ///////////////////

                    function closeDialog(){
                        //add attributes to dialog
                        angular.element(modalMain).attr({'aria-hidden': 'true','tab-index': '-1','open': false}); 
                        //set focus back to button that opened modal
                        openModalButton.focus();
                        openModalButton.scrollIntoView({block: "center"});
                    }                    

                    function openDialog(){
                        //add open class to modal to get styling and white background
                        angular.element(modalMain).toggleClass('open');                           

                        //add attributes to modal
                        angular.element(modalMain).attr({ 'aria-hidden': 'false','tab-index': '0','open': true});  

                        //focus on modal window (must not be before rest of page hidden)
                        modal.focus();                                                                    

                        //redirect last tab to first input
                        angular.element(closeModalButton).on('keydown', function(e){
                           if ((e.which === 9 && !e.shiftKey)) {
                               e.preventDefault();
                               modal.focus();
                           }
                        });

                        //redirect first shift+tab to last input
                        angular.element(modal).on('keydown', function(e){
                            if ((e.which === 9 && e.shiftKey)) {
                                e.preventDefault();
                                closeModalButton.focus();
                            }
                        });                       
                    }  

                     //Place modal as first child of #page node
                    function swap(){
                        p.parentNode.insertBefore(m, p);
                    }                                                      

                    e.preventDefault();
                });     
            }
        };
    }]);
})(window, window.angular);